import { createAsyncThunk } from '@reduxjs/toolkit';
import httpService from './httpService';

export const addNewProduct: any = createAsyncThunk<any>(
    'addNewProduct',
    async (data: any, { rejectWithValue }) => {
        try {
            const response = await httpService.post(
                '/productService/productV2',
                data
            );
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error?.response?.data);
        }
    }
);
export const editNewProduct: any = createAsyncThunk<any>(
    'editNewProduct',
    async (data: any, { rejectWithValue }) => {
        try {
            const response = await httpService.put(
                '/productService/productV2',
                data
            );
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error?.response?.data);
        }
    }
);
export const getNewProductList: any = createAsyncThunk<any>(
    'getNewProductList',
    async (data: any, { rejectWithValue }) => {
        try {
            const response = await httpService.get(
                '/productService/productV2/products',
                {
                    params: data
                }
            );
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error?.response?.data);
        }
    }
);
export const getNewProductDetails: any = createAsyncThunk<any>(
    'getNewProductDetails',
    async (data: any, { rejectWithValue }) => {
        try {
            const response = await httpService.get('/productService/productV2', {
                params: data
            });
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error?.response?.data);
        }
    }
);
export const swapNewProductImages: any = createAsyncThunk<any>(
    'swapNewProductImages',
    async (data: any, { rejectWithValue }) => {
        try {
            const response = await httpService.post(
                '/productService/imageV2/swapProductImages',
                data
            );
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error?.response?.data);
        }
    }
);
export const deleteNewProductList: any = createAsyncThunk<any>(
    'deleteNewProductList',
    async (data: any, { rejectWithValue }) => {
        try {
            const response = await httpService.delete(
                '/productService/productV2/products',
                {
                    params: data
                }
            );
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error?.response?.data);
        }
    }
);
export const updateNewProductStatus: any = createAsyncThunk<any>(
    'updateNewProductStatus',
    async (data: any, { rejectWithValue }) => {
        try {
            const response = await httpService.put(
                '/productService/productV2/products',
                data
            );
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error?.response?.data);
        }
    }
);
export const checkNewItemNumber: any = createAsyncThunk<any>(
    'checkNewItemNumber',
    async (data: any) => {
        const response = await httpService.get(
            `/productService/productV2/existItemNumber`,
            { params: data }
        );
        return response.data.data;
    }
);
export const checkNewBarcode: any = createAsyncThunk<any>(
    'checkNewBarcode',
    async (data: any) => {
        const response = await httpService.get(
            `/productService/productV2/barcodeDetails`,
            { params: data }
        );
        return response.data.data;
    }
);
export const getNewInventoryProductList: any = createAsyncThunk<any>(
    'getNewInventoryProductList',
    async (data: any, { rejectWithValue }) => {
        try {
            const response = await httpService.get(
                '/productService/productV2/inventoryProductList',
                {
                    params: data
                }
            );
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error?.response?.data);
        }
    }
);
export const swapVariantsNew: any = createAsyncThunk<any>(
    'swapVariantsNew',
    async (data: any, { rejectWithValue }) => {
        try {
            const response = await httpService.put(
                '/productService/productV2/changeVariantOrder',
                data
            );
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error?.response?.data);
        }
    }
);
export const updateVariantGroupInfo: any = createAsyncThunk<any>(
    'updateVariantGroupInfo',
    async (data: any, { rejectWithValue }) => {
        try {
            const response = await httpService.put(
                '/productService/productV2/updateVariantGroupInfo',
                data
            );
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error?.response?.data);
        }
    }
);
export const getProductCount: any = createAsyncThunk<any>(
    'getProductCount',
    async (data: any, { rejectWithValue }) => {
        try {
            const response = await httpService.get(
                '/productService/productV2/productCount',
                {
                    params: data
                }
            );
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error?.response?.data);
        }
    }
);
export const updateVariantType: any = createAsyncThunk<any>(
	'updateVariantType',
	async (data: any, { rejectWithValue }) => {
		try {
			const response = await httpService.put(
				'/productService/productV2/variantType',
				data
			);
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response?.data);
		}
	}
);

export const getTagSuggestionList: any = createAsyncThunk<any>(
    'getTagSuggestionList',
    async (data: any, { rejectWithValue }) => {
        try {
            const response = await httpService.get(
                '/productService/productV2/tags',
                {
                    params: data
                }
            );
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error?.response?.data);
        }
    }
);